/* HH: "Was hält Dich noch zurück?" bei Verlassabsicht im Warenkorb (Marco 22.10.2026, T-227).
   Markup und Texte in sections/hh-warenkorb-frage.liquid.
   Ausloeser, nur mit Ware im Warenkorb:
   - Desktop (Zeiger fein): Maus verlaesst das Fenster nach oben, waehrend die Schublade offen ist oder auf /cart.
     Die Schublade wird vorher geschlossen, sonst haelt Dawns trapFocus den Fokus darin fest.
   - Mobil: Schublade geschlossen, ohne zur Kasse zu gehen, aber nur wenn sie ueber das Warenkorb-Symbol
     geoeffnet wurde. Nach "In den Warenkorb" oeffnet Dawn sie von selbst; wer sie dann schliesst, kauft weiter ein.
   Sperren: nie bei offenem Cookie-Banner (hhNewsletter.bannerOffen), nie ueber dem offenen Newsletter-Popup.
   Einmal je Warenkorb: verstecktes Warenkorb-Attribut _hh_gefragt (Unterstrich, an der Kasse unsichtbar).
   Kein localStorage, kein sessionStorage, kein Cookie ausser dem Warenkorb-Cookie, den es ohnehin gibt.
   Zaehler: nur wenn data-zaehler gesetzt; schickt Frage, Antwort, Geraeteart und Warenkorbwert auf 10€
   gerundet, als text/plain ohne Kennung. */
(function () {
  var box = document.getElementById('hh-zoegern');
  if (!box || window.hhWarenkorbFrage) return;
  window.hhWarenkorbFrage = true;

  var karte = box.querySelector('[role="dialog"]');
  var wahl = box.querySelector('[data-hh-zoegern-wahl]');
  var schwelle = parseInt(box.dataset.schwelle, 10) || 4900;
  var zaehler = box.dataset.zaehler || '';
  var aufCartSeite = box.dataset.warenkorbseite === '1';
  var fein = window.matchMedia && window.matchMedia('(pointer: fine)').matches;
  var debug = new URLSearchParams(location.search).get('hh_frage') === '1';

  var offen = false, beantwortet = false, laeuft = false, erledigt = false;
  var vorher = null, wert = 0;

  function geld(cent) { return (cent / 100).toFixed(2).replace('.', ',') + '€'; }
  function stufe(cent) { var z = Math.floor(cent / 1000) * 10; return z + '-' + (z + 10); }

  function zaehle(antwort) {
    if (!zaehler) return;
    var daten = JSON.stringify({ f: 'zoegern', a: antwort, g: fein ? 'desktop' : 'mobil', w: stufe(wert) });
    try {
      fetch(zaehler, { method: 'POST', mode: 'no-cors', keepalive: true, credentials: 'omit',
        headers: { 'Content-Type': 'text/plain' }, body: daten }).catch(function () {});
    } catch (e) {}
  }

  function fokussierbar() {
    return Array.prototype.filter.call(
      karte.querySelectorAll('a[href], button:not([disabled]), input:not([tabindex="-1"])'),
      function (el) { return el.offsetParent !== null; });
  }
  function taste(e) {
    if (e.key === 'Escape') { zu(); return; }
    if (e.key !== 'Tab') return;
    var f = fokussierbar(); if (!f.length) return;
    var erst = f[0], letzt = f[f.length - 1];
    if (e.shiftKey && document.activeElement === erst) { e.preventDefault(); letzt.focus(); }
    else if (!e.shiftKey && document.activeElement === letzt) { e.preventDefault(); erst.focus(); }
  }

  function auf() {
    offen = true;
    vorher = document.activeElement;
    box.hidden = false;
    document.documentElement.classList.add('hh-zoegern-offen');
    document.addEventListener('keydown', taste);
    zaehle('gezeigt');
    setTimeout(function () { var f = fokussierbar(); (f[1] || karte).focus(); }, 30);
  }
  function zu() {
    if (!offen) return;
    offen = false;
    box.hidden = true;
    document.documentElement.classList.remove('hh-zoegern-offen');
    document.removeEventListener('keydown', taste);
    if (!beantwortet) zaehle('ohne-antwort');
    if (vorher && vorher.focus && document.contains(vorher)) vorher.focus();
  }
  Array.prototype.forEach.call(box.querySelectorAll('[data-hh-zoegern-zu]'), function (el) {
    el.addEventListener('click', zu);
  });

  Array.prototype.forEach.call(box.querySelectorAll('[data-antwort]'), function (knopf) {
    knopf.addEventListener('click', function () {
      var a = knopf.dataset.antwort;
      beantwortet = true;
      zaehle(a);
      wahl.hidden = true;
      var feld = box.querySelector('.hh-zoegern__antwort[data-fuer="' + a + '"]');
      if (a === 'versand') {
        var ueber = wert >= schwelle;
        Array.prototype.forEach.call(feld.querySelectorAll('[data-unter]'), function (el) { el.hidden = ueber; });
        Array.prototype.forEach.call(feld.querySelectorAll('[data-ueber]'), function (el) { el.hidden = !ueber; });
        var fehlt = feld.querySelector('[data-fehlt]');
        if (fehlt) fehlt.textContent = geld(Math.max(0, schwelle - wert));
      }
      feld.hidden = false;
      var ziel = feld.querySelector('input[type="email"], a[href], button');
      if (ziel && a !== 'preis') ziel.focus(); else karte.focus();
    });
  });

  function versuche() {
    if (offen || laeuft || erledigt) return;
    var popup = document.getElementById('hh-nl-popup');
    if (popup && !popup.hidden) return;
    laeuft = true;
    var banner = window.hhNewsletter && window.hhNewsletter.bannerOffen
      ? window.hhNewsletter.bannerOffen() : Promise.resolve(false);
    banner.then(function (blockiert) {
      if (blockiert) throw 'banner';
      return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
    }).then(function (cart) {
      if (!cart || !cart.item_count) return;
      if (cart.attributes && cart.attributes._hh_gefragt && !debug) { erledigt = true; return; }
      wert = cart.total_price || 0;
      erledigt = true;
      var schublade = document.querySelector('cart-drawer.active');
      if (schublade && schublade.close) schublade.close();
      auf();
      fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { _hh_gefragt: '1' } }) }).catch(function () {});
    }).catch(function () {}).then(function () { laeuft = false; });
  }

  if (window.Shopify && window.Shopify.designMode) return;
  if (debug) { setTimeout(versuche, 500); }

  var drawer = document.querySelector('cart-drawer');
  var selbst = false, zurKasse = false;

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('#cart-icon-bubble')) selbst = true;
    if (e.target.closest('[name="checkout"], a[href^="/checkout"], .additional-checkout-buttons')) zurKasse = true;
  }, true);
  document.addEventListener('submit', function (e) {
    if (e.submitter && e.submitter.name === 'checkout') zurKasse = true;
  }, true);

  if (drawer && !fein) {
    var warAktiv = drawer.classList.contains('active');
    new MutationObserver(function () {
      var aktiv = drawer.classList.contains('active');
      if (warAktiv && !aktiv && !offen) {
        if (selbst && !zurKasse) versuche();
        selbst = false;
      }
      warAktiv = aktiv;
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  if (fein) {
    document.addEventListener('mouseout', function (e) {
      if (e.relatedTarget || e.clientY > 0 || zurKasse) return;
      if (aufCartSeite || (drawer && drawer.classList.contains('active'))) versuche();
    });
  }
})();
